/**
 * 图片相关API
 */

import { API_PATHS } from "./config";
import axiosInstance from "../services/axiosConfig";
import Logger from "../utils/logger";

/**
 * 获取所有图片分类
 * @returns {Promise<Array>} 分类列表
 */
export const getImageCategories = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_PATHS.BASE_API_URL}/public/images/categories`
    );

    if (response.data.success) {
      Logger.info("获取图片分类成功", response.data.data);
      return response.data.data;
    } else {
      Logger.error("获取图片分类失败", response.data.message);
      return [];
    }
  } catch (error) {
    Logger.error("获取图片分类出错", error);
    return [];
  }
};

/**
 * 根据分类名称获取图片列表
 * @param {string} categoryName - 分类名称，如：飘带、背景、图标等
 * @returns {Promise<Array>} 图片列表
 */
export const getImagesByCategory = async (categoryName) => {
  try {
    const response = await axiosInstance.get(
      `${API_PATHS.BASE_API_URL}/public/images/by-category`,
      {
        params: { category_name: categoryName },
      }
    );

    if (response.success) {
      Logger.info(`获取分类 "${categoryName}" 的图片成功`, response.data);
      return response.data || [];
    } else {
      Logger.error(
        `获取分类 "${categoryName}" 的图片失败`,
        response.message
      );
      return [];
    }
  } catch (error) {
    Logger.error(`获取分类 "${categoryName}" 的图片出错`, error);
    return [];
  }
};

/**
 * 批量预加载图片
 * @param {Array} imageUrls - 图片URL数组
 * @returns {Promise<Array>} 成功加载的图片URL数组
 */
export const preloadImages = async (imageUrls) => {
  const loadPromises = imageUrls.map((url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(url);
      img.onerror = () => {
        Logger.warn(`图片加载失败: ${url}`);
        resolve(null);
      };
      img.src = url;
    });
  });

  const results = await Promise.all(loadPromises);
  return results.filter((url) => url !== null);
};

export default {
  getImageCategories,
  getImagesByCategory,
  preloadImages,
};
